define('js/lib/reloader',['vendor/wrapple'], function (wrapple) {
    'use strict';

    wrapple('location');

    return {
        reload: function () {
            wrapple.location().reload();
        },
        forceReload: function () {
            wrapple.location().reload(true);
        }
    };
});
